import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from '../../../../services/app.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { ActionButton } from '../../../../models/app/action-button';
import { PersonSearchRequest } from '../../../../models/net/request/person-search-request';
import { Person } from '../../../../models/data/app-core/person';
import { SearchComponent } from '../../../base/search/search.component';
import { PersonSearchResult } from '../../../../models/net/result/person-search-result';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { PersonService } from '../../../../services/persons/person.service';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';
@Component({
    selector: 'app-people',
    templateUrl: './persons.component.html',
    styleUrls: ['./persons.component.css', '../../../../app.component.css']
})

export class PersonsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "FirstName", "LastName", "UserUID", "Delete"];
    public override searchRequest: PersonSearchRequest = new PersonSearchRequest();
    public override searchResult: PersonSearchResult[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.PersonSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: PersonService) {

        super(appService, sessionService, itemService, "person", "Person");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.PersonSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: PersonSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: PersonSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId); // selectedSearchRequestIds = [searchPreference.DefaultSearchRequestId];

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: PersonSearchResult) => i.PersonId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: PersonSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
